// /* Import Section - Start */

// /* React Imports - Start */

// import React, { useEffect, useState } from "react";

// /* React Imports - End */

// /* Plugin Imports - Start */

// import { RadioButton } from "primereact/radiobutton";

// /* Plugin Imports - End */

// /* Import Section - End */

// /* Function - Start */

// const RadioElement = (props) => {
//   /* State Declaration - Start */

//   /* useState - Start */
//   const [radioOptions, setRadioOtopns] = useState(props.options);
//   const [selectedRadioValue, setSelectedValue] = useState("");

//   /* useState - End */

//   /* State Declaration - End */

//   /* Methods - Start */

//   const setRadio = (e) => {
//     setSelectedValue(e.value);
//     props.onChangeRadio(e.value);
//     if (props.survey === true) {
//       props.radioClick(e);
//     }
//   };

//   /* Methods - End */

//   /* useEffect - Start */

//   useEffect(() => {
//     if (props.value != undefined) {
//       setSelectedValue(props.value);
//     }
//     setRadioOtopns(props.options);
//   }, [props.value, props.options]);

//   /* useEffect - End */

//   /* Render View Return - Start */

//   return (
//     radioOptions !== undefined &&
//     radioOptions.length > 0 &&
//     radioOptions.map((option) => {
//       return (
//         <div className="d-flex">
//           <div
//             key={Math.random() * 10}
//             className={`field-radiobutton ${props.className}`}
//           >
//             <RadioButton
//               inputId={option.key}
//               name="radioGroup"
//               className="ml-2"
//               value={option.key}
//               checked={selectedRadioValue === option.key}
//               onChange={(e) => {
//                 setRadio(e);
//               }}
//               disabled={props.disabled}
//             />
//             <label className="label-radio ml-2" htmlFor={option.key}>
//               {option.name}
//             </label>
//           </div>
//         </div>
//       );
//     })
//   );

//   /* Render View Return - End */
// };

// /* Function - End */

// /* Export default functionName; */

// export default RadioElement;

import React, { useState, useEffect } from "react";
import { RadioButton } from "primereact/radiobutton";
import { useIsEdited } from "../../Providers/IsEditedProvider";
// import './MyComponent.css'; 
// Assuming the CSS is in a file named MyComponent.css

const RadioElement = (props) => {
  const [radioOptions, setRadioOptions] = useState(props.options);
  const [selectedRadioValue, setSelectedValue] = useState("");
  const { setIsEdited } = useIsEdited();

  const setRadio = (e) => {
    setIsEdited(true);
    setSelectedValue(e.value);
    props.onChangeRadio(e.value);
    if (props.survey === true) {
      props.radioClick(e);
    }
  };

  useEffect(() => {
    if (props.value != undefined) {
      setSelectedValue(props.value);
    }
    setRadioOptions(props.options);
  }, [props.value, props.options]);

  return (
    <div className="radio-buttons-row">
      {radioOptions !== undefined &&
        radioOptions.length > 0 &&
        radioOptions.map((option) => {
          return (
            <div className={`field-radiobutton ${props.className}`} key={option.key}>
              <RadioButton
                inputId={option.key}
                name="radioGroup"
                value={option.key}
                checked={selectedRadioValue === option.key}
                onChange={(e) => setRadio(e)}
                disabled={props.disabled}
              />
              <label className="ml-2" htmlFor={option.key}>
                {option.name}
              </label>
            </div>
          );
        })}
    </div>
  );
};

export default RadioElement;
